import { PetModel } from "./pet.model"
import { PetProcsModel } from "./pet-proc.model"

export class PetTreatmentModel {
    pet:PetModel
    pet_procs: PetProcsModel[]

    constructor(
        pet:PetModel,
        pet_procs: PetProcsModel[]
    ) { 
        this.pet = pet
        this.pet_procs = pet_procs 
    }


}


export class Home_PetTreatmentsModel {
    public pet_no: number;
    public pet_name: string;
    public item_type: string;
    public code_category: string;

    constructor(
        pet_no: number,
        pet_name: string,
        item_type: string,
        code_category: string
    ) {
        this.pet_no = pet_no;
        this.pet_name = pet_name;
        this.item_type = item_type;
        this.code_category = code_category;
    }
}